import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AddAppointmentsSchedule,
  GetMentors,
} from "../services/AppointmentsService";
import { updateMentors } from "../store/slices/mentorsSlice";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  generateCohortScheduleData,
  reshapedAppointments,
} from "../utils/reshapData";
import { handleAppointmentRequests } from "../utils/calendarHelpers";
import { JoinCohort } from "../services/cohortService";
import { queryClient } from "../App";

export const useAppointments = (type = "appointment") => {
  const [rawData, setRawData] = useState([]);
  const qalortUser = useSelector((state) => state.user.userData);
  const getData = async () => {
    if (qalortUser?.id) {
      try {
        const { cohortsData, appointmentData } =
          await handleAppointmentRequests();

        const payload = reshapedAppointments(
          [
            ...appointmentData,
            ...generateCohortScheduleData(cohortsData, qalortUser),
          ],
          qalortUser
        );
        setRawData([...appointmentData, ...cohortsData]);

        return payload;
      } catch (error) {
        return [];
      }
    }
  };

  const query = useQuery({
    queryKey: ["appointments"],
    queryFn: async () => {
      const data = await getData();
      return data || [];
    },
  });

  const mutation = useMutation({
    mutationFn: type === "appointment" ? AddAppointmentsSchedule : JoinCohort,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["appointments"] });
    },
  });

  return {
    ...query,
    rawData,
    mutation,
  };
};
